import { toast } from 'react-toastify';

export const handleGraphQLError = (error, defaultMessage = 'An error occurred') => {
  console.error('GraphQL Error:', error);

  if (error.networkError) {
    toast.error('Network error. Please check your connection.');
    return;
  }

  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    const gqlError = error.graphQLErrors[0];
    const errorMessage = gqlError.message || defaultMessage;
    
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  } else {
    toast.error(defaultMessage);
  }
};

export const formatDate = (timestamp) => {
  if (!timestamp) return 'N/A';
  try {
    return new Date(parseInt(timestamp)).toLocaleString();
  } catch (error) {
    console.error('Error parsing timestamp:', timestamp);
    return 'Invalid Date';
  }
};
